// extracted by mini-css-extract-plugin
export var saDefaultHeaderSection = "saDefaultHeader-module--saDefaultHeaderSection--16BNA";
export var saDefaultText = "saDefaultHeader-module--saDefaultText--2ZM_W";
export var saDefaultTitle = "saDefaultHeader-module--saDefaultTitle--2_j-K";
export var saDefaultImage = "saDefaultHeader-module--saDefaultImage--3fdWL";
export var saDefaultButton = "saDefaultHeader-module--saDefaultButton--7Mb5E";
export var saBtn = "saDefaultHeader-module--saBtn--1w4A5";